// Base Icon component and types
export { default as Icon } from './Icon';
export type { IconProps } from './Icon';

// Location related icons
export { default as GlobeIcon } from './GlobeIcon';
export { default as MapPinIcon } from './MapPinIcon';
export { default as BuildingIcon } from './BuildingIcon';
export { default as RealEstateIcon } from './RealEstateIcon';

// User related icons
export { default as UserIcon } from './UserIcon';
export { UsersIcon } from './UsersIcon';
export { default as SettingsIcon } from './SettingsIcon';

// Business related icons
export { default as CompanyIcon } from './CompanyIcon';
export { default as HotelIcon } from './HotelIcon';
export { default as HajjUmrahIcon } from './HajjUmrahIcon';
export { default as BanknoteIcon } from './BanknoteIcon';

// Action related icons
export { default as EditIcon } from './EditIcon';
export { default as TrashIcon } from './TrashIcon';
export { default as PlusIcon } from './PlusIcon';
export { default as SearchIcon } from './SearchIcon';
export { default as CheckIcon } from './CheckIcon';
export { default as CopyIcon } from './CopyIcon';
export { default as DuplicateIcon } from './DuplicateIcon';
export { default as LinkIcon } from './LinkIcon';
export { default as DownloadIcon } from './DownloadIcon';

// Communication related icons
export { default as EnvelopeIcon } from './EnvelopeIcon';

// Security related icons
export { default as LockIcon } from './LockIcon';

// Notification related icons
export { default as AlertIcon } from './AlertIcon';
export { default as BellIcon } from './BellIcon';

// Calendar and Time related icons
export { default as CalendarIcon } from './CalendarIcon';
export { ClockIcon } from './ClockIcon';

// Navigation related icons
export { default as ArrowLeftIcon } from './ArrowLeftIcon';
export { default as ChevronLeftIcon } from './ChevronLeftIcon';
export { default as ChevronRightIcon } from './ChevronRightIcon';
export { default as ChevronUpIcon } from './ChevronUpIcon';
export { default as EyeIcon } from './EyeIcon';
export { default as EyeOffIcon } from './EyeOffIcon';

// Content related icons
export { default as BookOpenIcon } from './BookOpenIcon';
export { default as SparklesIcon } from './SparklesIcon';
export { default as CourseThumbnailIcon } from './CourseThumbnailIcon';
export { BookIcon } from './BookIcon';
export { GraduationCapIcon } from './GraduationCapIcon';

// Audio related icons
export { default as Volume2Icon } from './Volume2Icon';
export { default as VolumeXIcon } from './VolumeXIcon';
export { default as PlayIcon } from './PlayIcon';
export { default as PauseIcon } from './PauseIcon';
export { default as SpeakingFaceIcon } from './SpeakingFaceIcon';

// Achievement related icons
export { default as AwardIcon } from './AwardIcon';
export { default as TrophyIcon } from './TrophyIcon';
export { default as CheckCircleIcon } from './CheckCircleIcon';
export { default as XCircleIcon } from './XCircleIcon';
export { default as RotateCcwIcon } from './RotateCcwIcon';

// UI related icons
export { default as XIcon } from './XIcon';
export { default as ImageIcon } from './ImageIcon';
export { default as VideoIcon } from './VideoIcon';
export { default as UploadIcon } from './UploadIcon';
export { default as ListIcon } from './ListIcon';
